// extracted by mini-css-extract-plugin
module.exports = {"title":"SubjectSeo_title__SDaPx","text":"SubjectSeo_text__8VavP"};